<template>
  <span>
    <span class>{{minContent}}</span>
    <span class="show-more text-blue" v-if="isAllBtn" @click="showAll">全文</span>
  </span>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      minContent: "",
      isAllBtn: true
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.content.length > this.maxLength) {
        this.minContent = this.content.substr(0, this.maxLength);
        this.minContent += "...";
        this.isAllBtn = true;
      } else {
        this.isAllBtn = false;
        this.minContent = this.content;
      }
    },
    showAll() {
      this.isAllBtn = false;
      this.minContent = this.content;
    }
  }
};
</script>
<style lang='scss' scoped>
.show-more {
  padding: 0 12px;
}
</style>